import { useMemo } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useSegmentationSelector = () => {
  const trigger = useTriggerSelector();
  return useMemo(() => trigger.segmentation, [trigger.segmentation]);
};
